

import { Icon, Button, Row, Col, Badge } from 'antd';
import SojTerrainLocationSVPriceListView from '../../sojterrain/SojTerrainLocationSVPriceListView'
import SJPageScroll from '../../../views/SJPageScroll'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
import {  Link } from "react-router-dom"

import '../../../css/svlist_styles.css'


const _ = require('lodash') 
const React = require('react')


const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
   );
   
   const HeartIcon = props => <Icon component={HeartSvg} {...props} />
   
   
   
   class InvSearchBoardBody extends React.Component {
   
       constructor(props){
   
           super(props)
           let me = this
       }

       render(){
           const {my_data, sjofferselectparent} = this.props
           
           return (
           <article className="main-listhotels">
           {
                   my_data.map(o => {
                       let soj = o
                       //convet keys of o to uppercase
                       console.log('sv***soj**')
                       console.log(soj)
                       let assets_ob = soj["assets"]
           if( assets_ob &&  assets_ob.length > 0){
               soj['roomMeta']  = assets_ob[0]["name"]
               soj['roomsAvailable'] = assets_ob.length
           }else{
               soj['roomMeta']  = "2 SVQueen Bed"
               soj['roomsAvailable']  = 0
           }
                       let roomImgs = soj['imgs']
                       let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
                       if(roomImgs && (roomImgs.length > 0)) {
                            roomImg = roomImgs[0]
                       }
                       
                       console.log('sv888MAY6888IMGS', roomImg);

                       let terminals = soj["hotel"]['terminals']
                       let terminalOld = {"terminalCode": "MLS", "distance":87}
                       let terminal = null
                       if(terminals && (terminals.length > 0)) {
                            terminal = terminals[0]
                       }
                       //sv room
                       let rooms = soj["hotel"]['rooms']
                       
                       let room = null
                       let roomConent  =''
                       if(rooms && (rooms.length > 0)) {
                            room = rooms[0]
                            let { roomStays} = room
                            if (roomStays){
                               roomStays.forEach( stay => {
                                   roomConent = roomConent + `${stay.order} ${stay.stayType}`

                               })
                            }
                            roomConent = `${roomConent} - ${room.roomType}` 
                       }else{
                           o.bedroomcode = o.bedroomcode ? o.bedroomcode : "2"
                           roomConent = `${o.bedroomcode} SVQueen Beds`
                           
                       }
                       soj["roomConent"] = roomConent

                       //let terminalContent = `${terminal.distance} miles from ${terminal.terminalCode}`
                       
                       console.log('sv888MAY6888IMGS', roomImg);
                       let customerId = -1
                       let svcustProfile = {
                        "customerId": -6,
                        "addressId":-1
                    }
                       let priceInfo = {
                           o:o,
                          
                           customerId:customerId
                       }
                       let reservekey = 'insvreview'
                       let svr_location = {
                           "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                           "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                           "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                           "county": soj['county'] ? soj['county'] : "albanyt",
                           "city": soj['city'] ? soj['city'] : "albanyt",
                           "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                           "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                           "country": soj['country_name'] ? soj['country_name'] : "usa",
                          "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                          "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                           
                          "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                          "state":soj['state'] ? soj['state'] : "NY"

                       }
                       
                       if(terminal != null){
                           svr_location["nearest_airport_distance_mi_lvl"] = terminal.distance
                           svr_location["en_nearest_airports_lvl"] = terminal.terminalCode
                       }
                       return (
                           <div className="svr-spacelist-box-row1">
                           <div className="svr-spacelist-boxr-1">
                               <div className="gallery">
                                   <figure>
                                   <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                                   {/* <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                    */}
                                   <img src={`${roomImg}`} alt="Carpet Grass" />
                                    </Link> </span>
                                       
                                   </figure>
                               </div>
                           </div>
                           {/* 
                           
                            <SJPageScroll></SJPageScroll>
           */}
                          
                           <SojTerrainLocationSVPriceListView sjofferselectparent= {sjofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  svrlocation={svr_location}></SojTerrainLocationSVPriceListView>

                       </div>
                           
                       )
                   })
               }
              
               <div className="svr-spacelist-box-row1 svr-spacelist-box-row1-last">
                   <div className="svr-spacelist-boxr-1">
                       <div className="gallery">
                           <figure>
                           <span>	<Link to={`/svredsojourn`} > 
                           
                           <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                            </Link> </span>
                              
                           </figure>
                       </div>
                   </div>
   
                   <div className="svr-spacelist-boxl-2">
                       <div className="box-outer-listhotels">
                           <div className="box-left-listhotels">
                               <p className="m-para-text-first">
                                   <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                   <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                           away</text></span>
                                  
                               </p>
                           </div>
                           <div className="box-right-listhotels">
                               <p className="m-para-text-first">
                                   <text className="svr-hotel-rating">Excellent </text>
                                   <text className="f12 d-block">12345 reviews </text>
                               </p>
                           </div>
                       </div>
   
   
                       <div className="box-outer-listhotels">
                           <div className="box-left-listhotels">
                               <p className="m-para-text">
                                   <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                   <text className="f12  d-block"> 2 Queen Beds </text>
                               </p>
                           </div>
                           <div className="box-right-listhotels">
                               <p className="m-para-text">
                                   <text className="svr-hotel-stay">1night, 2days </text>
                                   <text className="svr-hotel-price d-block">$116 </text>
                               </p>
                           </div>
                       </div>
                       
                       <div className="box-outer-listhotels">
                           <div className="box-left-listhotels">
                               <p className="svr-hotel-avail">
                                   <text className="f19"> Only 8 Rooms left </text>
                               </p>
                           </div>
                           <div className="box-right-listhotels">
                               <p>
                             
                               </p>
                           </div>
                       </div>
   
   
                   </div>
   
   
               </div>
           </article>
   
          
         
   
      
   )

       }
    }

    export default InvSearchBoardBody